module.exports = __webpack_public_path__ + "img/cartillas-silabas-directas.a088f0b1.png";